import AddressForm, {AddressDisplay} from "../../components/AddressForm";
import React, {useEffect, useState} from "react";
import {Row, Col, Form, Button, Table} from "react-bootstrap";
import {useAuth} from "../../providers/authprovider";
import ResponseAlert from "../../components/ResponseAlert";

export function CompanyDisplay({rajcompany}){
    return (
        <>
            <div>{rajcompany.full_name} </div>
        </>
    )
}

export default function Rajcompanies(props){

    const {privilege} = props;
    const {rajcompanies} = useAuth();
    const [companies, setCompanies] = useState(undefined);
    const [formData, setFormData] = React.useState({full_name:'', nip:'', address:{}})
    const handleChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });
    const [alert, setAlert] = useState({show:false, error:""});


    useEffect(()=>{
        if(companies !== undefined)
            return;

        rajcompanies.get(null, ({success, error, content})=>{
            if(success)
               return setCompanies(content)

            setCompanies([]);
            setAlert({show:true, error:error});
        })

    })

    const onAddEditCompany = (company)=>{
        const index = companies.findIndex(c=>c.id === company.id);

        if(index > -1)
            companies.splice(index, 1, company)
        else
            companies.push(company)

        setCompanies([...companies])
    }

    const onChangeAddresState = (data)=>{
       setFormData({...formData, address: data.address})
    }

    const handleAddRajcompany = ()=>{
        const rajdata = {...formData}

        rajcompanies.add(rajdata, ({success, error, content})=>{
            if(success)
                return onAddEditCompany(content);

            setAlert({show:true, error:error});
        })
    }

    const setCompanyEdit = (company)=>{
        setFormData({...company});
    }



    let lp = 1;

    return (
        <Row >
            <ResponseAlert show={alert.show} error={alert.error} />
            <Col lg={6}>
                <Table size={"sm"} striped bordered hover>
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Pełna nazwa</th>
                        <th>NIP</th>
                        <th>Adres</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        companies && companies.map(company=>{
                            return (
                                <tr key={company.id} onClick={()=>setCompanyEdit(company)} className={"cursor-pointer"}>
                                    <td>{lp++}</td>
                                    <td>{company.full_name}</td>
                                    <td>{company.nip}</td>
                                    <td><AddressDisplay address={company.address} /></td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </Table>
            </Col>
            {
                privilege.edit &&
                <Col lg={6} >
                    <div className={"p-2"}>
                        <Form.Group size="lg" controlId="full_name">
                            <Form.Label>Pełna nazwa spółki</Form.Label>
                            <Form.Control
                                autoFocus
                                value={formData.full_name}
                                type="text"
                                name="full_name"
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </div>
                    <div className={"p-2"}>
                        <Form.Group size="lg" controlId="nip">
                            <Form.Label>NIP spółki</Form.Label>
                            <Form.Control
                                value={formData.nip}
                                type="text"
                                name="nip"
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </div>
                    <div className={"p-2"}>
                        <AddressForm onChange={onChangeAddresState}  default={formData.address} />
                    </div>

                    <Button block={"block"} size="lg" onClick={handleAddRajcompany}className={'mt-4'}>
                        Zapisz
                    </Button>

                </Col>
            }


        </Row>
    )
}